module.exports = "<svg width=\"16\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.716 12.527l-3.26-3.304c-.701-.712.366-1.765 1.069-1.053l3.259 3.303c.702.712-.366 1.766-1.068 1.054z\" fill=\"currentColor\"></path><path d=\"M6.78 12.53l6.881-6.88a.75.75 0 0 0-1.06-1.061l-6.881 6.88a.75.75 0 1 0 1.06 1.061z\" fill=\"currentColor\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-tick-small.svg
// module id = 916
// module chunks = 0